export default {
  minLength (min) {
    return (rule, value, callback) => {
      if (value !== undefined && value !== null && value !== '') {
        if (value.length < min) {
          callback(new Error(`长度不能小于${min}`))
        }
      }
      callback()
    }
  }
}
